import { component as defineComponent } from 'flightjs';

const PromotedUpgrade = function () {
    this.after('initialize', function () {
        this.on(document, 'uiPromotedUpgradeDismiss', this.dismissPromotedUpgrade);
    });

    this.dismissPromotedUpgrade = function (e, data) {
        const xhr = $.ajax({
            type: 'POST',
            url: data.url,
            data: {
                flag: `promoted-upgrade-${data.upgradeKey}-${data.listingId}-dismissed`,
            },
        });

        xhr.done((res) => {
            this.trigger('dataPromotedUpgradeDismissSucceeded');
        });

        xhr.fail((res) => {
            this.trigger('dataPromotedUpgradeDismissFailed');
        });
    };
};

export default defineComponent(PromotedUpgrade);



// WEBPACK FOOTER //
// ./src/web/js/contest/data/promoted-upgrade.js